<sh-page class="page-setting" theme="{{theme_color}}">

  <sh-card card-height="45em" class="card-content-wrapper" slot='left' label="Select Application">
    <sh-icon slot="functions" button size="s" icon="plus" id="newApp" [disabled]="!addApplicationPermission"
      onclick="document.querySelector('#addExternalApp').visible = true"></sh-icon>

    <sh-divider spacing="s"></sh-divider>

    <sh-tooltip label="Add New Application" target="newApp" placement="bottom-right" variation="short"></sh-tooltip>
    <sh-menu-item id="menuItem" *ngFor="let app of externalApplications" [label]="app.name"
      (click)='changeActive($event); getSecretKey(app._id, app.consumers)'>
    </sh-menu-item>

  </sh-card>

  <sh-card card-height="50em" class="right-card">

    <!-- Tabs Section
    <sh-tabs #tab>
      <sh-tab-item label="View Keys" active (click)="onTabChanged(0)"></sh-tab-item>
      <sh-tab-item label="Add Application" (click)="onTabChanged(1)"></sh-tab-item>
    </sh-tabs> -->

    <sh-table lwidth="30%" mwidth="60%" rwidth="10%">
      <!-- a table row can be placed in the 'header' slot of the table -->
      
      <sh-table-row slot="header">
        <!-- table-heads are used inside header rows -->
        <sh-table-head columns="4">Application Name</sh-table-head>
        <sh-table-head columns="4">App Added Date</sh-table-head>
        <sh-table-head columns="4">Key Generated Date</sh-table-head>
        <sh-table-head columns="4">Active Since</sh-table-head>
        <sh-table-head columns="4">Times Key Generated</sh-table-head>
        <sh-table-head columns="4">Latest Key Generated By</sh-table-head>
      </sh-table-row>
      <sh-table-row *ngIf="applicationKeyMapping">
        <!-- use 'columns', 'col-m' and 'col-s' for defining the span of a cell for diffferent breakpoints -->
        <sh-table-cell columns="4">{{applicationKeyMapping.containerName}}</sh-table-cell>
        <sh-table-cell columns="4">{{applicationKeyMapping.created | date: 'dd/MM/yyyy'}}</sh-table-cell>
        <sh-table-cell columns="4">{{applicationKeyMapping.publicKeyDetails.keyGenerated | date: 'dd/MM/yyyy'}}
        </sh-table-cell>
        <sh-table-cell columns="4">{{this.activeSinceDateDiff}}</sh-table-cell>
        <sh-table-cell columns="4">{{applicationKeyMapping.publicKeyDetails.count}}</sh-table-cell>
        <sh-table-cell columns="4">{{applicationKeyMapping.publicKeyDetails.userEmailId}}</sh-table-cell>
      </sh-table-row>
      <!-- rows can be repeated using your app's framework templating syntax -->
    </sh-table>

    <div id="request_access_card_key_table">
      <div *ngIf="applicationKeyMapping">
        <p class="access-key-p">
          <sh-text size='header-2'>Secret Key</sh-text>
          <sh-text size='body-2'> {{applicationKeyMapping.publicKeyDetails.publicKeyXml}} </sh-text>
        </p>
        <sh-divider spacing="s"></sh-divider>
        <p class="key-details-p">
          <sh-text size='header-2'>Passphrase</sh-text>
          <sh-text size='body-2'> {{applicationKeyMapping.publicKeyDetails.passphrase}} </sh-text>
        </p>
        <sh-text class="warningtext">This key will give the application access to VAL services.</sh-text>
        <sh-text class="warningtext">Please do not share the key</sh-text>
      
        <div class="Genbutton" *ngIf="selectedApplicationId">
          <sh-divider spacing="s"></sh-divider>
          <sh-button class="gen-btn" size="l" label='Generate New Key' (click)="requestSecretKey()">
          </sh-button>
          <sh-button size="l" label='Get Unity Plugin' (click)="getUsers(this.selectedApplicationId)"
            onclick="document.querySelector('#requestPlugin').visible = true">
          </sh-button>
        </div>
      </div>
    </div>


    <!-- Add External Application as Consumer Application Section -->
    <div *ngIf="selectedApplicationId">
      <sh-text size='header-2' class="consumer-title">Add Consumer Application</sh-text>
      <sh-grid spacing="m">
        <sh-dropdown columns="4" col-m="3" col-s="3" #selectedConsumers (click)="onSelectedConsumerApp()"
          id="application" label='Select Application' multi-select>
          <sh-menu-item *ngFor="let application of externalApplicationOptions" [label]="application.name"
            [value]="application.name"></sh-menu-item>
        </sh-dropdown>

        <div class="remove-app" columns="8" col-m="3" col-s="3">
          <sh-tag #removeApp class="appTag" *ngFor="let application of consumerApplication;let i = index"
            [label]="application" removable (closed)="onRemoveSelectedApp(application, i)">
          </sh-tag>
        </div>
        <div columns="4"></div>
        <div columns="8" class="save-button" *ngIf="consumerApplication">
          <sh-button label="Save" [disabled]="!isConsumerAppModified" (click)="saveConsumerApplication()"></sh-button>
        </div>
      </sh-grid>
    </div>
  </sh-card>
</sh-page>


<!-- Notification Section -->

<sh-notifications class="z-index-1000 notification-card">
  <sh-notification-item type="confirmation" label="Success" id="success" [visible]="showSuccess">
    {{showSuccessMessage}}
  </sh-notification-item>
</sh-notifications>


<!-- Error Model Section -->
<sh-modal class="z-index-1000" id="key-error-modal" label='Application Key Error' modal-height='200px' modal-width='500px'>
  <sh-text class="warningtext">{{errMessage}}</sh-text>
  <sh-button color='tertiary' slot='footer' label='Close'
    onclick="document.querySelector('#key-error-modal').visible = false"></sh-button>
</sh-modal>


<!-- Add New Application Model Section -->
<sh-modal id="addExternalApp" sticky label='Add External Application' modal-height='250px' modal-width='400px'>
  <div columns="12" [formGroup]="ApplicationNameGroup">
    <sh-input-text label='Application Name' [value]="applicationName"
      (value-changed)="applicationName=$event.target.value" id="appName" formControlName="ApplicationNameControl"
      ngDefaultControl name="app" [value]="applicationName"
      [error]="ApplicationNameGroup.get('ApplicationNameControl').touched && ApplicationNameGroup.get('ApplicationNameControl').hasError('required')">
    </sh-input-text>
    <sh-tooltip
      *ngIf="ApplicationNameGroup.get('ApplicationNameControl').touched && ApplicationNameGroup.get('ApplicationNameControl').hasError('required')"
      label="Please enter the Application Name" target="appName" placement="bottom-right" variation="short">
    </sh-tooltip>
  </div>
  <sh-button color='tertiary' slot='footer' label='Cancel'
    onclick="document.querySelector('#addExternalApp').visible = false "></sh-button>
  <sh-button color='tertiary' slot='footer' label='Ok' [disabled]="!ApplicationNameGroup.valid"
    (click)="addExternalApplication()" onclick="document.querySelector('#addExternalApp').visible = false"></sh-button>
</sh-modal>


<!-- Request Unity Plugin Model Section -->
<sh-modal class="z-index-1000" id="requestPlugin" sticky label='Request Unity Plugin' modal-height='500px' modal-width='450px'>
  <div *ngIf="users != null">
    <sh-menu-item class="text-align-center" id="menuItem" *ngFor="let user of users" [label]="user.userEmailId"
      (click)='changeActive($event); requestedUserEmailId = user.userEmailId'>
    </sh-menu-item>
  </div>

  <sh-button color='tertiary' slot='footer' label='Cancel' (click)="requestedUserEmailId = ''"
    onclick="document.querySelector('#requestPlugin').visible = false;"></sh-button>
  <sh-button size="m" slot='footer' label='Download' (click)="requestUnityPlugin()" [disabled]="!requestedUserEmailId"
    onclick="document.querySelector('#requestPlugin').visible = false"></sh-button>
</sh-modal>